import React, {useState} from "react";

const Burger = ({className, children}) => {
	const [isOpen,setIsOpen] = useState(false)
	return (
		<div className={`burger-wrap ${className}`}>
			<span onClick={()=>setIsOpen(true)}>
				<div/>
				<div/>
				<div/>
			</span>
			<div className={`burger-menu ${isOpen ? '' : 'hide'}`}>
				<div>
					<span onClick={()=>setIsOpen(false)}>
						<div/>
						<div/>
					</span>
					<div className={'menu-child'}>
						{children}
					</div>
				</div>
			</div>
		</div>
	)
}

export default Burger;